import { Grid, Typography } from "@material-ui/core";
import { UserField, UserInputTypeKey } from "common/components/input/fields";
import { SubformProps } from "common/components/SubformProps";
import { UpdateUserManageable, UserManageable } from "common/store/user/types";
import React from "react";
import { useTranslation } from "react-i18next";

export const UserInfoSubform = (props: SubformProps<UpdateUserManageable>) => {
  // Hooks
  const { t } = useTranslation();

  return (
    <Grid container direction="column" spacing={5}>
      <Grid item xs={12}>
        <Typography variant="body1" color="textSecondary">
          {t("In order to approve you as an investor on our platform, please share the following information with us")}
        </Typography>
      </Grid>

      {UserManageable.isCompany(props.values) &&
      <Grid container item direction="row" spacing={5}>
        <Grid item xs>
          <UserField id={"company" as UserInputTypeKey} subkey="representativeFirstName" {...props} />
        </Grid>

        <Grid item xs={12} lg={6} md={6} sm={6}>
          <UserField id={"company" as UserInputTypeKey} subkey="representativeLastName" {...props} />
        </Grid>
      </Grid>
      }

      <Grid container item direction="row" spacing={5}>
        <Grid item xs>
          <UserField id={"gender" as UserInputTypeKey} {...props} />
        </Grid>

        <Grid item xs={12} lg={6} md={6} sm={6}>
          <UserField id={"cellphone" as UserInputTypeKey} {...props} />
        </Grid>
      </Grid>

      <Grid item container direction="row" spacing={5}>
        <Grid item lg={6} xs={12} md={6} sm={6}>
          <UserField id={"birthDate" as UserInputTypeKey} {...props} />
        </Grid>

        <Grid item lg={6} md={6} xs={12} sm={6}>
          <UserField id={"birthCity" as UserInputTypeKey} {...props} />
        </Grid>
      </Grid>

      <Grid container item direction="row" alignItems="center" spacing={5}>
        <Grid item lg={6} md={6} xs={12} sm={6}>
          <UserField id={"citizenship" as UserInputTypeKey} className="autocomplete" {...props} />
        </Grid>

        <Grid item xs={12} lg={6} md={6} sm={6}>
          <UserField id={"taxNumber" as UserInputTypeKey} {...props} />
        </Grid>
      </Grid>

      <Grid item xs={12}>
        <UserField id={"politicallyExposed" as UserInputTypeKey} {...props} />
      </Grid>

      {props.values.politicallyExposed &&
    <Grid item xs={12}>
      <UserField id={"politicallyExposedReason" as UserInputTypeKey} {...props} />
    </Grid>
      }

      <Grid item className="checkbox-center-container" xs={12}>
        <UserField id={"notUSTax" as UserInputTypeKey} {...props} />
      </Grid>
    </Grid>
  );
};
